<script lang="ts">
 import { onMount } from "svelte"
 import Board from "./Board.svelte"
 import Keyboard from "./Keyboard.svelte"
 import Info from "./Info.svelte"
 import Settings from "./Settings.svelte"

 import { get } from "svelte/store"
 import { game, GameMode } from "./game.ts";
 import { message, errorMessage, notInDictMessage, alreadySolvedWotdMessage } from "./state.ts";

 onMount(() => {
     $game.cmd_firstStart();
 })

 function addToDict() {
     $game.cmd_suggestWord($game.query_currentWord())
     $game.cmd_commit()
 }

 let infoOpened = !localStorage.getItem("second_rodeo") || window.location.hash === "info";
 function toggleInfo() {
     localStorage.setItem("second_rodeo", 1);
     infoOpened = !infoOpened
 }
 let settingsOpened = false;
 function toggleSettings() {
     settingsOpened = !settingsOpened;
 }

 function showNotification(text: string) {
     // TODO
     console.log("Notification: ", text)
 }

 function reset() {
     $game.cmd_reset();
     $game.cmd_sync_url();
 }

 let emojiBtn;

 function copyEmojiText() {
     const txt = $game.query_emojiText()
     navigator.clipboard.writeText(txt)
     showNotification("Скопировано в буфер обмена!")
     if (emojiBtn) {
         emojiBtn.innerText = "Скопировано!";
     }
 }

 let canCopy = 'clipboard' in navigator
</script>
<header>
    <div class="left">
        <button on:click={toggleInfo} class="infobtn" title="о Словле">Что это?</button>
    </div>
    <h1>Словль{#if $game.currentMode === GameMode.WOTD}&nbsp;№{$game.currentDay}{:else}&nbsp;<small>(рандом)</small>{/if}</h1>
    <div class="right">
        <button on:click={toggleSettings} class="settingsbtn" title="Настройки">Настройки</button>
    </div>
</header>

<Info visible={infoOpened} toggleInfo={toggleInfo} />
<Settings visible={settingsOpened} toggleSettings={toggleSettings} />

<main class="all">
    <Board />
    {#if $alreadySolvedWotdMessage}
        <div class="message">
            <div class="message-text">
                {#if $alreadySolvedWotdMessage.suggestRandom}
                    Словль дня ужё решен! Может, рандом?
                {:else}
                    Доступен Словль №{$alreadySolvedWotdMessage.currentDay}
                {/if}
            </div>
            <div class="message-buttons">
                {#if $alreadySolvedWotdMessage.suggestRandom}
                    <a class="link-button" href="{$alreadySolvedWotdMessage.randomUrl}">Случайное слово</a>
                {:else}
                    <a class="link-button" href="{$alreadySolvedWotdMessage.currentUrl}">Перейти к Словлю №{$alreadySolvedWotdMessage.currentDay}</a>
                {/if}
                <button on:click="{() => $alreadySolvedWotdMessage.dismiss()}">Решать Словль №{$alreadySolvedWotdMessage.day}</button>
            </div>
        </div>
    {/if}
    {#if $message}
        <div class="message">
            <div class="message-text">
                {#if $game.query_hasExtra()}
                    {@html $game.query_extra()}
                {:else}
                    {$message}
                {/if}
            </div>

            <div class="message-buttons">
                <button on:click={reset}>Другое слово</button>
                {#if canCopy}<button bind:this={emojiBtn} on:click={copyEmojiText}>Эмоджи</button>{/if}
            </div>
        </div>
    {/if}

    {#if $errorMessage}
        <div class="message">
            {$errorMessage}
        </div>
    {/if}

    {#if $notInDictMessage}
        <div class="message">
            {$notInDictMessage}
            <button on:click={addToDict}>Добавить</button>
            <button on:click={() => $game.cmd_backspace()}>Отмена</button>
        </div>
    {/if}
    <Keyboard />
</main>

<style>
 :global(html), :global(body) {
     width: 100%;
     height: 100%;
 }
 :global(body) {
     background: #fff8dc;
     font-size: 8px;
 }

 @media screen and (min-width: 300px) {
     :global(body) { font-size: 12px; }
 }

 @media screen and (min-width: 460px) {
     :global(body) { font-size: 13px; }
 }

 @media screen and (min-width: 650px) {
     :global(body) { font-size: 14px; }
 }

 @media screen and (min-width: 750px) {
     :global(body) { font-size: 15px; }
 }

 @media screen and (min-width: 850px) {
     :global(body) { font-size: 16px; }
 }

 .infobtn, .settingsbtn {
     display: inline-block;
     background: transparent;
 }

 header {
     text-align: center;
     font-size: .75em;

     border-bottom: 0.1px solid #999;
     display: grid;
     grid-template-columns: 25% 1fr 25%;
     padding-left: 6px;
     padding-right: 6px;
 }

 header h1 {
     font-size: 1.618em;
     flex-grow: 1;
 }

 .left {
     text-align: left;
 }

 .right {
     text-align: right;
 }

 .all {
     margin: 0 auto;
     display: flex;
     flex-direction: column;
     justify-content: space-between;
     align-items: center;
     max-width: 60em;
 }

 .all :global(.keyboard) {
     flex-grow: 1;
     align-self: flex-end;
 }

 .all :global(.board) {
     flex-shrink: 1;
     flex-grow: 1;
 }

.message {
    background: #555;
    color: #fff;
    border: 2px solid #555;
    position: absolute;
    border-radius: 3px;
    bottom: 1%;
    padding: 1em;
    z-index: 1;
    
    margin: auto;
    font-size: 1.25em;
    min-height: 2.5em;
}

.message-text {
    margin-bottom: 1em;
}

.message-text :global(a) {
    color: inherit;
    text-decoration: underline;
}

.message button, .message-buttons .link-button {
    cursor: pointer;
    border: 1px solid currentColor;
    display: inline-block;
    color: inherit;
    background: inherit;
    padding: .5em;
    font-size: inherit;
    border-width: 1px;
    border-bottom-width: 3px;
    margin-top: 2px;
}

.message button:active, .message-buttons .link-button:active {
    transform: translate(0, 2px);
    border-bottom-width: 1px;
}

 :global(.feather) {
     width: 1em;
 }
</style>
